module.exports = __webpack_public_path__ + "img/apoyo-social.bee905fc.jpg";